import React from 'react';
import styled from 'styled-components';

interface Props {
    color: string;
    children?: string;
}

const Nav = styled.nav`
    color: ${(props) => props.color};
    display: inline;
`;

const Paint: React.FC<Props> = ({ color, children }) => <Nav key={Math.random()} color={color}>{children}</Nav>

export default Paint;